import React, { useState } from 'react';
import PropTypes from 'prop-types';
import jsLang from '../lib/jslang';
import errorIcon from '../../svg/exclamation-circle.svg';
import Auth from '../lib/auth';
import LoadingButton from './ui/LoadingButton';
import Alert from './ui/Alert';

const LoginForm = ({
    apiKey, appId, authDomain, projectId, pwd, recaptchaKey, url,
}) => {
    const [data, setData] = useState({
        email: null, password: null,
    });
    const [failed, setFailed] = useState(false);
    const [loading, setLoading] = useState(false);

    Auth.init({
        apiKey, appId, authDomain, projectId, recaptchaKey,
    });

    const change = event => {
        const {
            value, name,
        } = event.target;

        setData({
            ...data,
            [name]: value.trim(),
        });
    };

    const submit = async event => {
        event.preventDefault();

        setFailed(false);
        setLoading(true);

        await Auth.login(data.email, data.password)
            .then(userCredential => userCredential._tokenResponse.idToken)
            .then(token => url.replace('_token_', token))
            .then(redirection => window.location.assign(redirection))
            .catch(() => {
                setFailed(true);
                setLoading(false);
            });
    };

    return (
        <form onSubmit={ submit }>
            <Alert
                dismissable
                icon={ errorIcon }
                id="errors"
                show={ failed }
                text={ jsLang.get('auth.failed') }
                type="danger"
            />

            <div className="form__group">
                <label className="hidden" htmlFor="email">
                    { jsLang.get('auth.form.email') }
                </label>
                <input
                    className="form__control form__field"
                    type="email"
                    id="email"
                    name="email"
                    placeholder={ jsLang.get('auth.form.email') }
                    required
                    onChange={ change }
                />
            </div>

            <div className="form__group">
                <label className="hidden" htmlFor="password">
                    { jsLang.get('auth.form.password') }
                </label>
                <input
                    className="form__control form__field"
                    type="password"
                    id="password"
                    name="password"
                    placeholder={ jsLang.get('auth.form.password') }
                    required
                    onChange={ change }
                />
            </div>

            <div className="form__group flex justify-between">
                <a
                    className="btn btn--passive v-align-content-centre"
                    id="forgot-password-link"
                    href={ pwd }
                >
                    { jsLang.get('auth.login.forgotPassword') }
                </a>
                <LoadingButton
                    className="btn btn--primary v-align-content-centre"
                    id="submit-button"
                    text={ jsLang.get('auth.login.submit') }
                    isLoading={ loading }
                />
            </div>
        </form>
    );
};

LoginForm.propTypes = {
    apiKey: PropTypes.string.isRequired,
    appId: PropTypes.string.isRequired,
    authDomain: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    pwd: PropTypes.string.isRequired,
    recaptchaKey: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default LoginForm;
